module.exports = __webpack_public_path__ + "files/7777a4d34567356eb4b98ff21b0c3b6e.png";